export default function () {
  const widgetName = 'cardWidgetVideo';
  const widgetOpts = cardWidgetVideoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (slide) {
      function addClass() {
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          let vimeoURLAttr = $(slide.items[x].Description).find('iframe').attr('src');
          vimeoURLAttr = `${vimeoURLAttr}&background=1`;

          $(this).find('.card-widget-description iframe').attr('src', vimeoURLAttr);

          $(this).find('.buttonwrap').remove();

          // let titleLoaded = $(this).find('.card-content .card-widget-title').text();
        });
      }
      addClass();
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev', 'Next'],
      nav: true,
    },
    textOverImage: true,
  });
}
